export const ScoreComponent = ({ title, description, score, keyDic }) => {
  return (
    <div className="card w-96 bg-base-100 shadow-xl">
      <div className="card-body">
        <h2 className="card-title">{title}</h2>
        <p>{description}</p>
        <div className="card-actions justify-end">
          <div className="stats shadow">
            {!(
              keyDic === "risque_financier" ||
              keyDic === "simplification_ambitions"||
              keyDic === "besoin_assistance"
            ) && (
              <div className="stat">
                <div className="stat-title">
                  {score < 7 ? "Nécessite un accompagnement" : "Bon score"}
                </div>
                <div
                  className={
                    " stat-value " +
                    (score >= 7 ? " text-green-600 " : " text-red-600 ")
                  }
                >
                  {score}/10
                </div>
              </div>
            )}
                        {(
              keyDic === "besoin_assistance"
            ) && (
              <div className="stat">
                <div className="stat-title">
                  {score >= 5 ? "Nécessite un accompagnement" : "Bon score"}
                </div>
                <div
                  className={
                    " stat-value " +
                    (score >= 7 ? " text-red-600 " : " text-green-600 ")
                  }
                >
                  {score}/10
                </div>
              </div>
            )}
            {keyDic === "risque_financier" && score > 6 && (
              <p className="text-error">
                Nous vous conseillons de prendre rendez-vous avec nous car nous
                avons décelé que ce projet pourrait potentiellement apporté des
                pertes que vous ne souhaiteriez pas
              </p>
            )}
            {keyDic === "risque_financier" && score <= 6 && (
              <p className="text-success">
                Il existe des risques mais vous en avez conscience
              </p>
            )}
            {keyDic === "simplification_ambitions" && score > 6 && (
              <p className="text-error">
                Nous vous conseillons de prendre rendez-vous avec nous car nous
                avons décelé que vous devriez réaliser votre projet en ayant une
                stratégie de priorisation des objectifs.
              </p>
            )}
            {(keyDic === "simplification_ambitions" && score <= 6 && score >= 0) && (
              <p className="text-success">
                Il semble que le projet soit bien expliqué. Vous pouvez passer à
                l'étape de la réalisation si les autres scores sont corrects.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
